import { sound } from '@pixi/sound';

export class AudioManager {
  private static instance: AudioManager;

  private muted = false;
  private musicVolume = 0.6;
  private sfxVolume = 1.0;

  private constructor() {}

  public static getInstance(): AudioManager {
    if (!AudioManager.instance) {
      AudioManager.instance = new AudioManager();
    }

    return AudioManager.instance;
  }

  public setMuted(value: boolean): void {
    this.muted = value;
    sound.muteAll();
    if (!value) {
      sound.unmuteAll();
    }
  }

  public isMuted(): boolean {
    return this.muted;
  }

  public setMusicVolume(volume: number): void {
    this.musicVolume = this.clamp(volume, 0, 1);
    sound.volumeAll = this.musicVolume;
  }

  public setSfxVolume(volume: number): void {
    this.sfxVolume = this.clamp(volume, 0, 1);
  }

  public playMusic(trackName: string, loop = true): void {
    if (this.muted) {
      return;
    }

    // Check if sound exists before trying to play it
    if (!sound.exists(trackName)) {
      console.warn(`Music track '${trackName}' not found - skipping playback`);
      return;
    }

    sound.play(trackName, {
      loop,
      volume: this.musicVolume
    });
  }

  public playSfx(effectName: string): void {
    if (this.muted) {
      return;
    }

    // Check if sound exists before trying to play it
    if (!sound.exists(effectName)) {
      console.warn(`Sound effect '${effectName}' not found - skipping playback`);
      return;
    }

    sound.play(effectName, {
      loop: false,
      volume: this.sfxVolume
    });
  }

  private clamp(value: number, min: number, max: number): number {
    return Math.max(min, Math.min(max, value));
  }
}
